import React, { useCallback } from 'react';
import { useAppDispatch } from '../../../../../redux/hooks';
import { IDateInput } from '../../../../../redux/slices/oldBuilder/date/types';
import useDashboardConfigSelector from '../../../../../redux/selectorHooks/useDashboardConfigSelector';
import { dashboardCustomizationSetDateRange } from '../../../../../redux/slices/dashboards/dashboardInstance';
import useDashboardSelector from '../../../../../redux/selectorHooks/useDashboardSelector';
import OptionalDatePickerWidget from '../../../../../components/Builder/DatePickerWidget/OptionalDatePickerWidget';
import { MaybeNil } from '../../../../../utils/interfaces';
import useDashboardSchemaId from '../../../utils/useDashboardSchemaId';

const DashboardCustomizationDateRange = () => {
  const dispatch = useAppDispatch();
  const { defaultEnd, defaultDatePicker } =
    useDashboardConfigSelector('config');
  const schemaId = useDashboardSchemaId();

  const draftCustomization = useDashboardSelector('draftCustomization');
  const draftDateRange = draftCustomization.dateRange;
  const draftDatePicker = draftCustomization.datePicker;

  const handleDateChange = useCallback(
    (dateInput: MaybeNil<IDateInput>) => {
      dispatch(
        dashboardCustomizationSetDateRange({
          newDateInput: dateInput,
        }),
      );
    },
    [dispatch],
  );

  return (
    <OptionalDatePickerWidget
      endDate={defaultEnd}
      onChange={handleDateChange}
      datePicker={draftDatePicker}
      dateRange={draftDateRange}
      defaultDatePicker={defaultDatePicker}
      schemaId={schemaId}
    />
  );
};

export default DashboardCustomizationDateRange;
